import videojs from 'video.js';

function copyToClipboard(el, cb) {
  el && el.select();

  try {
    document.execCommand('copy');
    cb && cb();
  } catch (err) {
    console.log('Videojs share: unable to copy');
  }
}

function isMobile() {
  return /iP(hone|ad|od)|Android|Windows Phone/.test(navigator.userAgent);
}

var utils = {
  copyToClipboard: copyToClipboard,
  isMobile: isMobile
};

export default utils;